import PropTypes from "prop-types";
import { ContentMenuModal } from "../Layout/templates";

const CalculatorMenuModal = ({ isOpen, onClose }) => {
  const calculatorMenuItems = [
    {
      id: "ccbwcalc",
      title: "Creatinine clearance calculator for adults",
      path: "/calculator/ccbwcalc",
    },
    {
      id: "gfrcalc",
      title: "Glomerular filtration rate (GFR) calculator for children",
      path: "/calculator/gfrcalc",
    },
    {
      id: "bsacalc",
      title: "Body surface area calculator",
      path: "/calculator/bsacalc",
    },
    {
      id: "ibwcalc",
      title: "Ideal body weight calculator",
      path: "/calculator/ibwcalc",
    },
    {
      id: "lbwcalc",
      title: "Lean body weight calculator",
      path: "/calculator/lbwcalc",
    },
    {
      id: "idcalc",
      title: "Aminoglycoside initial dose calculator for adults",
      path: "/calculator/idcalc",
    },
  ];

  return (
    <ContentMenuModal
      isOpen={isOpen}
      onClose={onClose}
      title="Calculators"
      icon="tg-icons-Calculator"
      menuItems={calculatorMenuItems}
    />
  );
};

CalculatorMenuModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default CalculatorMenuModal;
